<div class="brand-panel w-100 h-100">
  <div class="brand-head">
    <app-logo></app-logo>
  </div>

  <div class="brand-body">
    <h1 class="brand-title">
      Todos os seus canais de venda
      <span class="brand-accent">em um só lugar.</span>
    </h1>
    <p class="brand-sub">
      Pedidos, estoque e notas fiscais sincronizados entre os marketplaces e o seu ERP.
    </p>
  </div>

  <div class="brand-partners">
    <span class="brand-partners-label">Integrações</span>
    <div class="brand-logos">
      <img src="/assets/images/logos/mercado_livre.svg" alt="Mercado Livre" />
      <img src="/assets/images/logos/bling.svg" alt="Bling" />
      <img src="/assets/images/logos/tray.svg" alt="Tray" />
      <img src="/assets/images/logos/vision.svg" alt="Vision" />
    </div>
  </div>
</div>
